import AnimatedPage from "../components/animatedPage"
import Coverage from "../components/news/coverage"
import MediaCoverageBanner from "../components/news/mediaCoverageBanner"
import ScrollToTop from "../components/scrollToTop"


const MediaCoverage = () => {
  return (
    <AnimatedPage>
    {/* <ScrollToTop/> */}
    <MediaCoverageBanner/>
    <Coverage/>
    </AnimatedPage>
  )
}

export default MediaCoverage